import { isNumber } from '../utils';
import { AggregatingValidator, messages } from '../errors';
const MAX_SAFE_INTEGER = 9007199254740991;
export class QueryValidator extends AggregatingValidator {
    constructor(operatorName, previousInvalidArguments) {
        super(previousInvalidArguments);
        this.operatorName = operatorName;
    }
    _isNumber(specifier, operand) {
        return this.addValidation(() => isNumber(operand), () => messages.queryValidations.isNumber(this.operatorName, specifier, operand));
    }
    isPositiveNumber(operand) {
        return this._isNumber('positive', operand).addValidation(() => !Number.isNaN(operand) && operand > 0, () => messages.queryValidations.isPositiveNumber(this.operatorName, operand));
    }
    isNonNegativeNumber(operand) {
        return this._isNumber('non-negative', operand).addValidation(() => !Number.isNaN(operand) && operand >= 0, () => messages.queryValidations.isNonNegativeNumber(this.operatorName, operand));
    }
    isInteger(operand) {
        return this.addValidation(() => !Number.isNaN(operand) &&
            Number.isFinite(operand) &&
            Number.isInteger(operand) &&
            operand < MAX_SAFE_INTEGER &&
            operand > -MAX_SAFE_INTEGER, () => messages.queryValidations.isInteger(this.operatorName, operand));
    }
    isOptionalInteger(operand) {
        if (operand === undefined) {
            return this;
        }
        return this.isInteger(operand);
    }
    notGreaterThan(operand, value) {
        return this.addValidation(() => operand <= value, () => messages.queryValidations.notGreaterThan(this.operatorName, operand, value));
    }
    nonEmptyString(operand) {
        return this.addValidation(() => typeof operand === 'string' && operand.length > 0, () => messages.queryValidations.isNonEmptyString(this.operatorName));
    }
}
//# sourceMappingURL=QueryValidator.js.map